export default "__VITE_ASSET__1465034c__"